import React, {Component} from 'react';
import styles from './Video.scss';
import classNames from 'classnames/bind';
import ReactPlayer from 'react-player';

const cx = classNames.bind(styles);

class Video extends Component {
  render() {
    const {src, poster} = this.props;

    return (
      <div className={cx('Video-wrapper')}>
        <ReactPlayer
          className={cx('Video')}
          width={'100%'}
          height={'100%'}
          url={src}
          playing
          muted
          loop
          playsinline
          config={{
            file: {
              attributes: {poster: poster}
            }
          }}
          style={{
            objectFit: 'cover'
          }}
        />
        <div className={cx('Video__layer')}/>
      </div>
    );
  };
}

export default Video;


// WEBPACK FOOTER //
// ./src/app/intro/components/Video/Video.js